// extracted by mini-css-extract-plugin
export var boxItems = "_aj-1";
export var button = "_aj-5";
export var filterGroupBox = "_aj-0";
export var icon = "_aj-2";
export var iconSecondary = "_aj-4";
export var iconWrapper = "_aj-3";